export default [{
        path: "*",
        meta: {
            public: true
        },
        redirect: {
            path: "/404"
        }
    },
    {
        path: "/404",
        meta: {
            public: true
        },
        name: "NotFound",
        component: () =>
            import( /* webpackChunkName: "routes" */
                `@/views/NotFound.vue`)
    },
    {
        path: "/login",
        meta: {
            public: true
        },
        name: "Login",
        component: () =>
            import( /* webpackChunkName: "routes" */
                `@/views/Login.vue`)
    },
    {
        path: "/forgot-password",
        meta: {
            public: true
        },
        name: "Forgot",
        component: () =>
            import( /* webpackChunkName: "routes" */
                `@/views/Forgot.vue`)
    },
    {
        path: "/two-factor",
        meta: {
            public: true
        },
        name: "TwoFactor",
        component: () =>
            import( /* webpackChunkName: "routes" */
                `@/views/TwoFactor.vue`)
    },
    {
        path: "/dashboard",
        meta: {
            public: false
        },
        name: "Dashboard",
        component: () => import( /* webpackChunkName: "about" */ `@/views/Dashboard.vue`)
    },
    {
        path: "/purchase-order",
        name: "PurchaseOrder",
        meta: {
            public: false,
            breadcrumb: true
        },
        component: () => import( /* webpackChunkName: "about" */ `@/views/PurchaseOrder.vue`)
    },
    {
        path: "/purchase-order/:idPO/:idJOB",
        meta: {
            public: false,
            breadcrumb: true,
            breadcrumbList: [{
                text: "Purchase Order",
                disable: false,
                to: "/purchase-order"
            },
                {
                    text: "Detail",
                    disabled: true,
                    href: "#"
                }
            ]
        },
        name: "JobDetail",
        component: () => import( /* webpackChunkName: "about" */ `@/views/JobDetail.vue`)
    },
    {
        path: "/purchase-order/:id",
        meta: {
            public: false,
            breadcrumb: true,
            breadcrumbList: [{
                    text: "Purchase Order",
                    disable: false,
                    to: "/purchase-order"
                },
                {
                    text: "Job",
                    disabled: true,
                    to: "#"
                }
            ]
        },
        name: "Job",
        component: () => import( /* webpackChunkName: "about" */ `@/views/JobForm.vue`)
    },
    {
        path: "/reference_number",
        name: "ReferenceNumber",
        meta: {
            public: false,
            breadcrumb: true
        },
        component: () => import( /* webpackChunkName: "about" */ `@/views/ReferenceNumber.vue`)
    },
    {
        path: "/reference_number/:id",
        meta: {
            public: false,
            breadcrumb: true,
            breadcrumbList: [{
                    text: "Reference Number",
                    disable: false,
                    to: "/reference_number"
                },
                {
                    text: "Reference Number Detail",
                    disabled: true,
                    to: "#"
                }
            ]
        },
        name: "Reference_Number_Detail",
        component: () => import( /* webpackChunkName: "about" */ `@/views/ReferenceNumberDetail.vue`)
    },
    {
        path: "/job-status",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "JobStatus",
        component: () => import( /* webpackChunkName: "about" */ `@/views/JobStatus.vue`)
    },
    {
        path: "/repair-reason",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "RepairReason",
        component: () => import(/* webpackChunkName: "about" */ `@/views/RepairReason.vue`)
    },
    {
        path: "/repair-item",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "RepairItem",
        component: () => import(/* webpackChunkName: "about" */ `@/views/RepairItem.vue`)
    },
    {
        path: "/replaced-spare-part",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "ReplacedSparePart",
        component: () => import(/* webpackChunkName: "about" */ `@/views/ReplacedSparePart.vue`)
    },
    {
        path: "/spare-part",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "SparePart",
        component: () => import(/* webpackChunkName: "about" */ `@/views/SparePart.vue`)
    },
    {
        path: "/extra-task",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "ExtraTask",
        component: () => import(/* webpackChunkName: "about" */ `@/views/ExtraTask.vue`)
    },
    {
        path: "/model",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "Model",
        component: () => import(/* webpackChunkName: "about" */ `@/views/Model.vue`)
    },
    {
        path: "/payment-method",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "PaymentMethod",
        component: () => import(/* webpackChunkName: "about" */ `@/views/PaymentMethod.vue`)
    },
    {
        path: "/manager-user",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "User",
        component: () => import( /* webpackChunkName: "about" */ `@/views/User.vue`)
    },
    {
        path: "/manager-sale",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "SaleRepresentative",
        component: () => import( /* webpackChunkName: "about" */ `@/views/SaleRepresentative.vue`)
    },
    {
        path: "/quality",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "Quality",
        component: () => import( /* webpackChunkName: "about" */ `@/views/Quality.vue`)
    },
    {
        path: "/quote",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "Quote",
        component: () => import( /* webpackChunkName: "about" */ `@/views/Quote.vue`)
    },
    {
        path: "/timekeeping",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "Timekeeping",
        component: () => import( /* webpackChunkName: "about" */ `@/views/Timekeeping.vue`)
    },
    {
        path: "/storage-item/:parent_id?",
        meta: {
            public: false,
            breadcrumb: true
        },
        name: "StorageItem",
        component: () => import( /* webpackChunkName: "about" */ `@/views/StorageItem.vue`)
    },
    {
        path: "/profile",
        meta: {
            public: false
        },
        name: "Profile",
        component: () => import( /* webpackChunkName: "about" */ `@/views/Profile.vue`)
    },
    {
        path: "/",
        meta: {
            public: true
        },
        redirect: {
            path: "/login"
        }
    },
    {
        path: "/about",
        name: "about",
        meta: {
            public: true
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( /* webpackChunkName: "about" */ `@/views/About.vue`)
    }
];
